import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { createGlobalStyle } from 'styled-components';
import { FontTags } from './fonts';
export const GlobalStyleStyled = createGlobalStyle `
  /* modern-normalize v1.1.0 | MIT License | https://github.com/sindresorhus/modern-normalize */

  /*
  Document
  ========
  */

  /**
  Use a better box model (opinionated).
  */

  *,
  ::before,
  ::after {
    box-sizing: border-box;
  }

  /**
  1. Correct the line height in all browsers.
  2. Prevent adjustments of font size after orientation changes in iOS.
  3. Use a more readable tab size (opinionated).
  */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
    -moz-tab-size: 4; /* 3 */
    tab-size: 4; /* 3 */
  }

  /*
  Sections
  ========
  */

  /**
  1. Remove the margin in all browsers.
  */

  body {
    color: ${({ theme }) => theme.ColorGrey800};
    font-family:
      ${({ theme }) => theme.FontTextText300FontFamily},
      Helvetica,
      Arial,
      sans-serif;
    font-size: ${({ theme }) => pxToRems(theme.FontTextText300FontSize)};
    font-weight: ${({ theme }) => theme.FontTextText300FontWeight};
    letter-spacing: ${({ theme }) => pxToRems(theme.FontTextText300LetterSpacing)};
    line-height: ${({ theme }) => pxToRelative(theme.FontTextText300LineHeight)};
    margin: 0; /* 1 */
  }

  /*
  Grouping content
  ================
  */

  /**
  1. Add the correct height in Firefox.
  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
  */

  hr {
    height: 0; /* 1 */
    color: inherit; /* 2 */
  }

  /*
  Text-level semantics
  ====================
  */

  /**
  Add the correct text decoration in Chrome, Edge, and Safari.
  */

  abbr[title] {
    text-decoration: underline dotted;
  }

  /**
  Add the correct font weight in Edge and Safari.
  */

  b,
  strong {
    font-weight: bolder;
  }

  /**
  1. Improve consistency of default fonts in all browsers. (https://github.com/sindresorhus/modern-normalize/issues/3)
  2. Correct the odd 'em' font sizing in all browsers.
  */

  code,
  kbd,
  samp,
  pre {
    font-family:
      ui-monospace,
      SFMono-Regular,
      Consolas,
      'Liberation Mono',
      Menlo,
      monospace; /* 1 */
    font-size: 1em; /* 2 */
  }

  /**
  Add the correct font size in all browsers.
  */

  small {
    font-size: 80%;
  }

  /**
  Prevent 'sub' and 'sup' elements from affecting the line height in all browsers.
  */

  sub,
  sup {
    font-size: .625em;
    line-height: 0;
    position: relative;
  }

  sub {
    vertical-align: sub;
  }

  sup {
    vertical-align: super;
    top: .15em;
  }

  /*
  Tabular data
  ============
  */

  /**
  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
  */

  table {
    text-indent: 0; /* 1 */
    border-color: inherit; /* 2 */
  }

  /*
  Lists
  ============
  */

  /**
  1. Remove left padding from the list elements
  2. Remove margin from the list elements
  */

  ul, ol {
    padding-left: 0; /* 1 */
    margin: 0; /* 2 */
  }

  /*
  SVG
  ============
  */

  /**
  1. Ensure all SVGs inherit the surrounding text colour
  */

  svg {
    fill: currentColor;
  }

  /*
  Forms
  =====
  */

  /**
  1. Change the font styles in all browsers.
  2. Remove the margin in Firefox and Safari.
  */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
  Remove the inheritance of text transform in Edge and Firefox.
  */

  button,
  select {
    text-transform: none;
  }

  /**
  Correct the inability to style clickable types in iOS and Safari.
  */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
  Remove the inner border and padding in Firefox.
  */

  ::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
  Restore the focus styles unset by the previous rule.
  */

  :-moz-focusring {
    outline: 1px dotted ButtonText;
  }

  /**
  Remove the additional ':invalid' styles in Firefox.
  See: https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737
  */

  :-moz-ui-invalid {
    box-shadow: none;
  }

  /**
  Remove the padding so developers are not caught out when they zero out 'fieldset' elements in all browsers.
  */

  legend {
    padding: 0;
  }

  /**
  Add the correct vertical alignment in Chrome and Firefox.
  */

  progress {
    vertical-align: baseline;
  }

  /**
  Correct the cursor style of increment and decrement buttons in Safari.
  */

  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    height: auto;
  }

  /**
  1. Correct the odd appearance in Chrome and Safari.
  2. Correct the outline style in Safari.
  */

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
  Remove the inner padding in Chrome and Safari on macOS.
  */

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
  1. Correct the inability to style clickable types in iOS and Safari.
  2. Change font properties to 'inherit' in Safari.
  */

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /*
  Interactive
  ===========
  */

  /*
  Add the correct display in Chrome and Safari.
  */

  summary {
    display: list-item;
  }

  /*
  ReCAPTCHA
  ===========
  */

  /*
  Hide the ReCAPTCHA badge
  */

  .grecaptcha-badge {
    visibility: hidden;
  }
`;
export const pxToRems = (px) => {
    const numPx = typeof px === 'string' ? parseInt(px) : px;
    return `${numPx / 16}rem`;
};
export const pxToRelative = (px) => {
    const numPx = typeof px === 'string' ? parseInt(px) : px;
    return numPx / 16;
};
/**
 * Adds or changes opacity value for CSS rgb/rgba color syntax
 * @param {string} rgb - CSS rgb/rgba rgb(12, 34, 56) or rgba(12, 34, 56, 0.7)
 * @param {string|number} opacity - New opacity value <= 1
 * @returns {string} Returns CSS rgba syntax with added or changed opacity value
 */
export const rgbOpacity = (rgb, opacity) => {
    return rgb?.replace(/rgba?\((\s*\d{1,3}\s*,\s*\d{1,3}\s*,\s*\d{1,3}\s*)((?:,\s*[0-9.]*\s*)?)\)/, `rgba($1, ${opacity})`);
};
/**
 * This component is used to inject a global CSS reset which sets some baseline styles including:
 *
 * - Box sizing
 * - Base font size, font weight, font family, font colour, letter spacing, line height
 * - We use [modern-normalise](https://github.com/sindresorhus/modern-normalize) as a base and then build our custom defaults in using theme tokens
 *
 * It also is responsible for loading the Fonts for the theme from the Google Fonts API by default, unless there are `fontOverrides` defined in `design-tokens`.
 * In this case, the font will be downloaded from the location specified in the override.
 *
 * It should be used once, near the top level of an MFE, inside the `<AwazeThemeProvider>` component.
 */
export const GlobalStyle = () => {
    return (_jsxs(_Fragment, { children: [_jsx("link", { rel: "preconnect", href: "https://fonts.googleapis.com" }), _jsx("meta", { name: "viewport", content: "width=device-width, initial-scale=1.0" }), _jsx("link", { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" }), _jsx(FontTags, {}), _jsx(GlobalStyleStyled, {})] }));
};
//# sourceMappingURL=global-style.js.map